import { InvoiceEditorDialog, type InvoiceEditorSpec } from '../dialogs/invoice-editor-dialog';

import type {
  BlContextForTradeInvoice,
  TicketContextForTradeInvoice,
} from '../dialogs/trade-invoice-payload';
import type { TradeInvoiceType } from '../lib/trade-invoice-type';
import type { InvoiceRow } from '../types';

export type RowDialogKind =
  | { kind: 'trade'; type: TradeInvoiceType }
  | { kind: 'adjustment'; noteType: 'Credit' | 'Debit' }
  | { kind: 'advance' };

export interface RowEditDialogProps {
  readonly kind: RowDialogKind;
  readonly invoice: InvoiceRow;
  readonly side: 'buy' | 'sell';
  readonly orderId: string;
  readonly blOrderId: string;
  readonly ticket: TicketContextForTradeInvoice;
  readonly bl: BlContextForTradeInvoice;
  readonly open: boolean;
  readonly onOpenChange: (open: boolean) => void;
  readonly onSaved: () => void;
}

function toEditorSpec(kind: RowDialogKind): InvoiceEditorSpec {
  if (kind.kind === 'trade') return { kind: 'trade', type: kind.type };
  if (kind.kind === 'advance') return { kind: 'advance' };
  return { kind: 'adjustment', noteType: kind.noteType };
}

// A row's Edit affordance: the unified editor opened on the existing invoice.
export function RowEditDialog(props: RowEditDialogProps) {
  return (
    <InvoiceEditorDialog
      spec={toEditorSpec(props.kind)}
      open={props.open}
      onOpenChange={props.onOpenChange}
      side={props.side}
      orderId={props.orderId}
      blOrderId={props.blOrderId}
      existingInvoice={props.invoice}
      ticket={props.ticket}
      bl={props.bl}
      onSaved={props.onSaved}
    />
  );
}
